import { defineMessages } from 'react-intl';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Add Payment Method',
    description: 'Header text for the add payment method modal',
    id: '2z+Zp2',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'Text for the cancel button in the manage payment method flow',
    id: 'FW8sIS',
  },
  saveButton: {
    defaultMessage: 'Save',
    description: 'Text for the save button in the manage payment method flow',
    id: 'qzQG1q',
  },
});

export const assignedPreferencesMessages = defineMessages({
  [TransactionCategory.AddFunds]: {
    description: 'Assigned preference for Shipstation Balance',
    defaultMessage: 'ShipStation Balance',
    id: 'iHzUVy',
  },
  [TransactionCategory.Subscription]: {
    description: 'Assigned preference for Subscription',
    defaultMessage: 'Subscription',
    id: 'vQPlsl',
  },
  [TransactionCategory.Store]: {
    description: 'Assigned preference for Store',
    defaultMessage: 'Store',
    id: 'kf0KWT',
  },
});
